import styled from "styled-components";
import Login from "./resources/Login";
import Transactions from "./resources/user_pages/Transactions";
import UserHome from "./resources/user_pages/Home";
import AdminHome from "./resources/admin_pages/Home";
import Sidebar from "./resources/Sidebar";
import Transfer from "./resources/user_pages/Transfer";
import Users from "./resources/admin_pages/Users";
import CreditDebit from "./resources/admin_pages/CreditDebit";
import UserProvider from "./resources/UserContext";
import { BrowserRouter, Switch, Route } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <UserProvider>
        <Container className="App">
          <Sidebar />
          <Content>
            <Switch>
              <Route path="/" component={Login} exact />
              <Route path="/user/home" component={UserHome} />
              <Route path="/user/transactions" component={Transactions} />
              <Route path="/user/transfer" component={Transfer} />
              <Route path="/admin/home" component={AdminHome} />
              <Route path="/admin/users" component={Users} />
              <Route path="/admin/transfer" component={CreditDebit} />
            </Switch>
          </Content>
        </Container>
      </UserProvider>
    </BrowserRouter>
  );
}
const Content = styled.div`
  padding: 4em;
`;
const Container = styled.div`
  display: flex;
  background-color: #f1f6fa;
`;
export default App;
